module.exports = __webpack_public_path__ + "static/portfolio3-b7635e868cc1e37dfbeffbf5375cbe69.jpg";